// The full nail profile, staff side. /pages/headquarters?client=<id>
//
// A VIEW of headquarters rather than the customer's own /pages/nail-profile
// with a staff branch bolted on. That page is full of customer things (the
// "ur nail profile is ready" hero, the delete-my-account button) and mixing
// two audiences into one file means every future edit is a chance for one to
// leak into the other. The security half matters more: on a shared page the
// only thing between customer A and customer B's hand photos would be an `if`
// in theme code, which runs in the visitor's browser where it can be edited.
// This renders nothing until the Worker has confirmed a staff session.
//
// Opened in a new tab from the board, so headquarters keeps its scroll
// position and its open conversation.

(function () {
  'use strict';

  var FINGERS = ['pinky', 'ring', 'middle', 'index', 'thumb'];
  var PHOTO_SLOTS = [
    ['leftThumb', 'left thumb'], ['leftFingers', 'left fingers'], ['leftFront', 'left curve'],
    ['rightThumb', 'right thumb'], ['rightFingers', 'right fingers'], ['rightFront', 'right curve']
  ];

  var S = null;      // shared state from tn-headquarters.js
  var root = null;
  var data = null;

  function esc(s) { return window.HQ.esc(s); }

  // Shape, length and jewel tone are stored in ONE canonical spelling
  // (lowercase, set by the Worker) because the builder and the product page
  // used to disagree and split the same shape in two. Capitalisation is a
  // display decision, so it happens here.
  //
  // xl / xxl go fully upper, not "Xl".
  function spec(v) {
    return String(v == null ? '' : v).split(',').map(function (part) {
      var s = part.trim();
      if (!s) return '';
      if (/^x{0,2}l$/i.test(s)) return s.toUpperCase();
      return s.charAt(0).toUpperCase() + s.slice(1);
    }).filter(Boolean).join(', ');
  }

  function post(p, b) { return window.HQ.post(p, b); }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }).toLowerCase();
  }
  function fmtShort(sec) {
    if (!sec) return '';
    var d = new Date(sec * 1000);
    return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' +
      String(d.getFullYear()).slice(-2);
  }

  // A blank slot is a DASH you can click, never a zero and never a hidden gap.
  // Tali's rule for both grids: show the row, show the gaps, let them be filled
  // whenever. Nothing is ever blocked on a number being missing.
  function cell(value, attrs) {
    return '<button class="hqc__cell" ' + attrs + '>' +
      (value == null || value === '' ? '—' : esc(value)) + '</button>';
  }

  // ── Render ──────────────────────────────────────────────────────────

  function render() {
    var c = data.customer;
    root.innerHTML =
      '<div class="hqc__head">' +
        '<a class="hqc__back" href="/pages/headquarters">← headquarters</a>' +
        '<h1 class="hqc__title"><span class="name">' + esc((c.name || 'their').split(' ')[0]) +
          '’s</span> full nail profile</h1>' +
      '</div>' +
      '<div class="hqc__layout">' +
        '<div class="hqc__col">' + ordersBox() + '</div>' +
        '<div class="hqc__col">' + photosBox() + measureBox() + notesRow() + '</div>' +
      '</div>' +
      '<div class="hqc__lb" id="hqc-lb" hidden>' +
        '<div class="hqc__lb-bar">' +
          '<span class="hqc__lb-title" id="hqc-lb-title"></span>' +
          '<span class="hqc__lb-count" id="hqc-lb-count"></span>' +
          '<button class="hqc__lb-save" id="hqc-lb-save">save to device ↓</button>' +
          '<button class="hqc__lb-x" id="hqc-lb-x" aria-label="close">✕</button>' +
        '</div>' +
        '<button class="hqc__lb-nav hqc__lb-nav--prev" id="hqc-lb-prev" aria-label="previous">‹</button>' +
        '<img id="hqc-lb-img" alt="">' +
        '<button class="hqc__lb-nav hqc__lb-nav--next" id="hqc-lb-next" aria-label="next">›</button>' +
        '<div class="hqc__lb-note">delete these off the device once the set is done</div>' +
      '</div>';

    wire();
  }

  function photosBox() {
    var p = data.photos;
    return '<div class="hqc__box hqc__box--dark">' +
      '<div class="hqc__box-head"><span>nail profile pics</span>' +
        '<span class="hqc__box-meta">coin: ' + esc(data.customer.coin || 'not given') + '</span></div>' +
      '<div class="hqc__photos">' +
        PHOTO_SLOTS.map(function (slot) {
          var url = p[slot[0]] || (slot[0] === 'leftFront' || slot[0] === 'rightFront' ? p.curve : null);
          return '<div class="hqc__photo">' +
            (url
              // Thumbnailed for the grid; the lightbox loads the full file, so
              // six full-size hand photos are not downloaded to show a grid.
              ? '<img src="' + esc(url.replace('/image/upload/', '/image/upload/c_limit,w_420,f_auto,q_auto/')) +
                  '" alt="' + esc(slot[1]) + '" data-full="' + esc(url) +
                  '" data-group="profile" data-title="' + esc(slot[1]) + '" loading="lazy">'
              : '<div class="hqc__photo-none">not uploaded</div>') +
            '<span class="hqc__photo-label">' + esc(slot[1]) + '</span>' +
          '</div>';
        }).join('') +
      '</div>' +
    '</div>';
  }

  function measureBox() {
    var m = data.measurements;
    var c = data.customer;

    function hand(side) {
      var w = side === 'left' ? m.leftWidth : m.rightWidth;
      var h = side === 'left' ? m.leftHeight : m.rightHeight;
      return '<div class="hqc__hand">' +
        '<span class="hqc__hand-label">' + side + '</span>' +
        '<div class="hqc__grid">' +
          '<div></div>' + FINGERS.map(function (f) {
            return '<div class="hqc__grid-h">' + f + '</div>';
          }).join('') +
          '<div class="hqc__grid-l">max width</div>' +
          w.map(function (v, i) {
            return cell(v == null ? null : v + 'mm',
              'data-m="' + side + 'Width" data-i="' + i + '"');
          }).join('') +
          '<div class="hqc__grid-l">nail bed height</div>' +
          h.map(function (v, i) {
            return cell(v == null ? null : v + 'mm',
              'data-m="' + side + 'Height" data-i="' + i + '"');
          }).join('') +
        '</div>' +
      '</div>';
    }

    return '<div class="hqc__box">' +
      '<div class="hqc__box-head hqc__box-head--plain">' +
        '<span>member since ' + esc(fmtDate(c.memberSince)) + '</span>' +
        '<span class="hqc__saved" id="hqc-saved">' +
          (data.stage.profile === 'complete' ? 'saved ✦' : 'measuring ✦') + '</span>' +
      '</div>' +
      '<div class="hqc__id">' +
        '<div class="hqc__handle script">' + esc(c.username || (c.name || '').split(' ')[0]) + '</div>' +
        '<div class="hqc__avatar"' +
          (c.avatar ? ' style="background-image:url(\'' +
            esc(c.avatar.replace('/image/upload/', '/image/upload/c_limit,w_240,f_auto,q_auto/')) +
            '\')"' : '') + '></div>' +
      '</div>' +
      hand('left') + hand('right') +
      '<div class="hqc__foot">✦ auto-applied to every set they order</div>' +
    '</div>';
  }

  function notesRow() {
    return '<div class="hqc__row2">' +
      '<div class="hqc__box hqc__box--warm">' +
        '<div class="hqc__box-head hqc__box-head--plain"><span>profile notes</span></div>' +
        // The customer's own words. Read-only on purpose: editing someone's
        // sentences and leaving them looking like theirs is a trap.
        '<div class="hqc__note hqc__note--ro">' +
          (data.notes.profile ? esc(data.notes.profile) : 'nothing from them') + '</div>' +
        '<div class="hqc__box-head hqc__box-head--plain"><span>staff notes</span></div>' +
        '<textarea class="hqc__note" id="hqc-snotes" placeholder="what the next person needs to know…">' +
          esc(data.notes.staff || '') + '</textarea>' +
      '</div>' +
      '<div class="hqc__box hqc__box--lilac">' +
        '<div class="hqc__box-head hqc__box-head--plain"><span>past sizes</span>' +
          '<button class="hqc__plus" id="hqc-addrecipe" title="add a set">＋</button></div>' +
        recipesBox() +
      '</div>' +
    '</div>';
  }

  function recipesBox() {
    if (!data.recipes.length) {
      return '<div class="hqc__empty">no sets recorded yet. ＋ adds one.</div>';
    }
    return data.recipes.map(function (r) {
      function side(which) {
        return r.sizes[which].map(function (v, i) {
          return cell(v, 'data-r="' + esc(r.shape) + '|' + esc(r.length) + '|' + which + '" data-i="' + i + '"');
        }).join('');
      }
      return '<div class="hqc__recipe">' +
        '<div class="hqc__recipe-head">' +
          '<span class="hqc__recipe-name">' + esc(spec(r.length) + ' ' + spec(r.shape)) + '</span>' +
          '<button class="hqc__recipe-x" data-del="' + esc(r.shape) + '|' + esc(r.length) +
            '" title="remove this set" aria-label="remove ' + esc(r.label) + '">✕</button>' +
        '</div>' +
        '<div class="hqc__recipe-row"><span>L</span>' + side('left') +
          '<span class="hqc__recipe-sep">|</span>' + side('right') + '<span>R</span></div>' +
      '</div>';
    }).join('');
  }

  function ordersBox() {
    if (!data.orders.length) {
      return '<div class="hqc__box"><div class="hqc__box-head hqc__box-head--plain"><span>orders</span></div>' +
        '<div class="hqc__empty">no orders yet</div></div>';
    }
    return '<div class="hqc__box">' +
      '<div class="hqc__box-head hqc__box-head--plain"><span>orders</span>' +
        '<span class="hqc__box-meta">' + data.orders.length + '</span></div>' +
      data.orders.map(function (o, idx) {
        var line = [o.shape, o.length, o.jewelTone].filter(Boolean).map(spec).map(esc).join(' · ');
        var kind = o.itemType === 'byo' ? 'byo' : o.itemType === 'giftcard' ? 'gift card' : 'collection';
        // EVERY order opens. The first version left collection orders flat, on
        // the grounds that their four facts were all visible collapsed -- which
        // was true, and still meant one row in the list silently refused to
        // respond to a click. A row that looks the same as its neighbours has
        // to behave the same as its neighbours; orderDetail() says plainly when
        // there is no design brief rather than the arrow just being absent.
        return '<div class="hqc__order" data-order="' + esc(o.id) + '">' +
          '<button class="hqc__order-top">' +
            '<span class="hqc__order-arrow">▸</span>' +
            '<span class="hqc__order-main">' +
              '<span class="hqc__order-line1">' + esc(window.HQ.shortDate(o.placedAt)) + '  ' +
                esc(o.orderName || '') + '  ' + esc(o.title || '') + '</span>' +
              '<span class="hqc__order-line2">' + kind + (line ? ' · ' + line : '') + '</span>' +
            '</span>' +
            '<span class="hqc__order-right">' + window.HQ.money(o.totalCents) +
              '<span class="hqc__order-stage">' + esc(o.stage.replace(/_/g, ' ')) + '</span></span>' +
          '</button>' +
          '<div class="hqc__order-body" hidden>' + orderDetail(o) + '</div>' +
        '</div>';
      }).join('') +
    '</div>';
  }

  // The two sliders are stored 0-100. "energy: 73" means nothing to a human,
  // so they draw as a position between the words the customer actually saw.
  //
  // THESE LABELS ARE THE BUILDER'S OWN, copied from main-nail-scratch.liquid.
  // The first version of this page invented "loud/subtle" and "flat/
  // dimensional", which described a slider the customer was never shown. If
  // the builder's wording changes, change it here too -- there is no shared
  // list, by choice, because putting one in means editing a live checkout page.
  var SLIDERS = {
    'Overall Energy':      ['sleek/simple', 'maxxximalist'],
    // The real control offers three labels (simple / small gems / 3d art).
    // Tali's call: show it as the two ends, since a position between them says
    // the same thing and reads far quicker.
    'Texture & Dimension': ['i keep it simple', 'i love 3d art!']
  };

  function scale(label, lo, hi, value) {
    var pct = Math.max(0, Math.min(100, Number(value) || 0));
    return '<div class="hqc__kv"><span class="hqc__k">' + esc(label) + '</span>' +
      '<span class="hqc__scale"><i>' + esc(lo) + '</i>' +
        '<span class="hqc__track"><b style="left:' + pct + '%"></b></span>' +
        '<i>' + esc(hi) + '</i></span></div>';
  }

  // _Colors is a list of HEX CODES, not colour names — nail-scratch.js pushes
  // currentHex() straight into the palette. Printing them as text gives
  // "#8b0000, #c1c2c6", which tells a human nothing. Swatches it is.
  //
  // A few entries are names rather than hex (the preset nudes), so anything
  // that is not a hex code falls back to a plain chip instead of a colour that
  // would silently render as black.
  function colorRow(label, value) {
    var parts = String(value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!parts.length) return '';
    var chips = parts.map(function (c) {
      return /^#[0-9a-fA-F]{3,8}$/.test(c)
        // Native title= works but waits about a second. A CSS tooltip shows the
        // moment you point at it, which is the difference between "what colour
        // is that" being answerable and being ignored.
        ? '<span class="hqc__swatch" style="background:' + esc(c) + '" data-hex="' + esc(c) +
            '" title="' + esc(c) + '"></span>'
        : '<span class="hqc__chip">' + esc(c) + '</span>';
    }).join('');
    return '<div class="hqc__kv hqc__kv--chips"><span class="hqc__k">' + esc(label) + '</span>' +
      '<span class="hqc__chips">' + chips + '</span></div>';
  }

  // Jewel tone is a MULTI-select (gold, silver, bronze, rose, pearl), so it
  // arrives comma separated and reads better as chips than as a sentence.
  function chipRow(label, value) {
    var parts = String(value || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!parts.length) return '';
    return '<div class="hqc__kv hqc__kv--chips"><span class="hqc__k">' + esc(label) + '</span>' +
      '<span class="hqc__chips">' +
        parts.map(function (c) { return '<span class="hqc__chip">' + esc(c) + '</span>'; }).join('') +
      '</span></div>';
  }

  function orderDetail(o) {
    var ctx = o.context || {};
    var out = '';

    // A collection order has no design brief and no inspo photos, so the set
    // itself is the whole answer to "what am I making". Name and its two
    // photos, first, before sizes and tracking.
    if (o.itemType !== 'byo') {
      var line = [o.shape, o.length, o.jewelTone].filter(Boolean).map(spec).map(esc).join(' · ');
      var pics = o.productImages || [];
      out += '<div class="hqc__sub">the set</div>' +
        '<div class="hqc__set">' +
          (pics.length
            ? '<div class="hqc__set-pics">' + pics.map(function (u) {
                return '<img src="' + esc(u) + (u.indexOf('?') > -1 ? '&' : '?') + 'width=420" ' +
                  'data-full="' + esc(u) + '" data-group="set-' + esc(o.id) +
                  '" data-title="' + esc(o.title || 'the set') + '" alt="" loading="lazy">';
              }).join('') + '</div>'
            : '') +
          '<div class="hqc__set-name">' + esc(o.title || 'set') + '</div>' +
          (line ? '<div class="hqc__set-spec">' + line + '</div>' : '') +
        '</div>';
    }

    // Design Name is deliberately absent: it is already the order's title at the
    // top of this row, and repeating it just pushed the label column wider.
    var brief = ['Vision', 'Likes', 'Dislikes', 'Preference', 'Final Notes'];
    var briefRows = brief.filter(function (k) { return ctx[k]; }).map(function (k) {
      return '<div class="hqc__kv"><span class="hqc__k">' + esc(k.toLowerCase()) +
        '</span><span class="hqc__v">' + esc(ctx[k]) + '</span></div>';
    }).join('');

    var colorRows = colorRow('colors', ctx['Colors']) + chipRow('jewel tone', spec(ctx['Jewel Tone']));

    if (briefRows || colorRows || ctx['Overall Energy'] || ctx['Texture & Dimension']) {
      out += '<div class="hqc__sub">what they asked for</div>' + briefRows + colorRows +
        (ctx['Overall Energy']
          ? scale('energy', SLIDERS['Overall Energy'][0], SLIDERS['Overall Energy'][1], ctx['Overall Energy'])
          : '') +
        (ctx['Texture & Dimension']
          ? scale('texture', SLIDERS['Texture & Dimension'][0], SLIDERS['Texture & Dimension'][1], ctx['Texture & Dimension'])
          : '');
    }

    // The inspiration they sent, which is the single most useful thing on the
    // whole card when you are about to make the set. Shown for every build,
    // including a build that arrived without any, because "they sent none" is
    // itself worth knowing before you go looking for them.
    if (o.itemType === 'byo') {
      var refs = o.referencePhotos || [];
      out += '<div class="hqc__sub">inspo photos' +
        (refs.length ? ' <span class="hqc__count">' + refs.length + '</span>' : '') + '</div>';
      out += refs.length
        ? '<div class="hqc__refs">' + refs.map(function (u) {
            return '<img src="' + esc(u.replace('/image/upload/', '/image/upload/c_limit,w_400,f_auto,q_auto/')) +
              '" data-full="' + esc(u) + '" data-group="inspo-' + esc(o.id) +
              '" data-title="inspo photo" alt="" loading="lazy">';
          }).join('') + '</div>'
        : '<div class="hqc__empty">none sent with this order</div>';
    }

    if (o.sizes) {
      out += '<div class="hqc__sub">sizes cut</div>' +
        '<div class="hqc__recipe-row"><span>L</span>' +
          o.sizes.left.map(function (v) { return '<span class="hqc__cell is-static">' + (v == null ? '—' : esc(v)) + '</span>'; }).join('') +
          '<span class="hqc__recipe-sep">|</span>' +
          o.sizes.right.map(function (v) { return '<span class="hqc__cell is-static">' + (v == null ? '—' : esc(v)) + '</span>'; }).join('') +
          '<span>R</span></div>';
    }

    if (o.trackingNumber) {
      out += '<div class="hqc__kv"><span class="hqc__k">tracking</span><span class="hqc__v">' +
        esc(o.trackingNumber) + '</span></div>';
    }
    if (o.orderNotes) {
      out += '<div class="hqc__sub">order notes</div><div class="hqc__v">' + esc(o.orderNotes) + '</div>';
    }
    return out;
  }

  // ── Interaction ─────────────────────────────────────────────────────

  // Which images the arrows move between. Whatever group you opened from --
  // the six hand shots, one order's inspo, or one set's two product photos --
  // and never across groups, because "next" landing on a different order's
  // photo is disorienting rather than helpful.
  var lbGroup = [];
  var lbIndex = 0;

  function lbShow(i) {
    if (!lbGroup.length) return;
    lbIndex = (i + lbGroup.length) % lbGroup.length;   // wraps both ways
    var item = lbGroup[lbIndex];
    root.querySelector('#hqc-lb-img').src = item.full;
    root.querySelector('#hqc-lb-title').textContent = item.title;
    root.querySelector('#hqc-lb-count').textContent =
      lbGroup.length > 1 ? (lbIndex + 1) + ' of ' + lbGroup.length : '';
    var solo = lbGroup.length < 2;
    root.querySelector('#hqc-lb-prev').hidden = solo;
    root.querySelector('#hqc-lb-next').hidden = solo;
  }

  function openLightbox(img) {
    var group = img.dataset.group || '';
    var imgs = [].slice.call(root.querySelectorAll('img[data-group="' + group + '"]'));
    lbGroup = imgs.map(function (el, i) {
      return {
        full: el.dataset.full,
        // A hand shot names the finger; anything in a numbered set says which
        // one of how many, so "next" always tells you where you are.
        title: el.dataset.title + (imgs.length > 1 && group !== 'profile' ? ' ' + (i + 1) : '')
      };
    });
    lbShow(imgs.indexOf(img));
    root.querySelector('#hqc-lb').hidden = false;
  }

  /**
   * Save the image the customer is looking at, at full size.
   *
   * Fetched into a blob rather than linked with `download`, because that
   * attribute is ignored cross-origin and would just navigate away from the
   * page. Every host involved (Shopify CDN, Cloudinary, the theme CDN) returns
   * Access-Control-Allow-Origin: *, which is what makes the fetch legal --
   * checked before building this, not assumed.
   */
  function saveCurrent() {
    var item = lbGroup[lbIndex];
    if (!item) return;
    var btn = root.querySelector('#hqc-lb-save');
    var was = btn.textContent;
    btn.textContent = 'saving…';
    var who = (data.customer.name || 'client').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var what = item.title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    var ext = (item.full.split('?')[0].match(/\.(jpg|jpeg|png|webp|heic)$/i) || [, 'jpg'])[1];

    fetch(item.full, { mode: 'cors' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
      .then(function (blob) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = who + '-' + what + '.' + ext;
        document.body.appendChild(a);
        a.click();
        a.remove();
        // Revoked on a delay: Safari needs the URL to still resolve after the
        // click returns, and a same-tick revoke silently saves nothing.
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
        btn.textContent = 'saved ✦';
        setTimeout(function () { btn.textContent = was; }, 1600);
      })
      .catch(function () {
        btn.textContent = was;
        window.TN && window.TN.showToast("Couldn't save that one — try opening it in a new tab.");
      });
  }

  function wire() {
    // Lightbox. Hand photos are the thing being measured, so being able to
    // actually look at one at full size is the point of the page.
    var lb = root.querySelector('#hqc-lb');
    root.addEventListener('click', function (e) {
      var img = e.target.closest('img[data-full]');
      if (img) return openLightbox(img);
      if (e.target.closest('#hqc-lb-save')) return saveCurrent();
      if (e.target.closest('#hqc-lb-prev')) return lbShow(lbIndex - 1);
      if (e.target.closest('#hqc-lb-next')) return lbShow(lbIndex + 1);
      if (e.target.closest('#hqc-lb-x')) { lb.hidden = true; return; }
      // Clicking the backdrop closes; clicking the picture or the bar does not.
      if (e.target.id === 'hqc-lb') lb.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lb.hidden = true;
      if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });

    // Collapsible orders.
    root.addEventListener('click', function (e) {
      var top = e.target.closest('.hqc__order-top');
      if (!top || top.disabled) return;
      var body = top.parentElement.querySelector('.hqc__order-body');
      if (!body) return;
      body.hidden = !body.hidden;
      top.querySelector('.hqc__order-arrow').textContent = body.hidden ? '▸' : '▾';
    });

    // Click a dash (or a number) to edit it, in both grids.
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.hqc__cell');
      if (b && !b.classList.contains('is-static')) editCell(b);
    });

    root.querySelector('#hqc-snotes').addEventListener('blur', function (e) {
      post('/api/staff/notes', {
        sessionToken: S.session.token, customerId: data.customer.id, notes: e.target.value
      });
    });

    root.querySelector('#hqc-addrecipe').addEventListener('click', addRecipe);

    // Remove a recipe. Added because it was possible to create one and then be
    // stuck with it -- an empty row with no way out is worse than no row.
    root.addEventListener('click', function (e) {
      var x = e.target.closest('[data-del]');
      if (!x) return;
      var parts = x.dataset.del.split('|');
      var shape = parts[0], length = parts[1];
      var rec = data.recipes.filter(function (r) {
        return r.shape === shape && r.length === length;
      })[0];
      var filled = rec
        ? ['left', 'right'].reduce(function (n, side) {
            return n + rec.sizes[side].filter(function (v) { return v != null; }).length;
          }, 0)
        : 0;
      window.HQ.dialog({
        title: 'remove ' + spec(length) + ' ' + spec(shape) + '?',
        // An empty one is obviously junk; one with numbers in it is somebody's
        // work, and the message should not treat the two the same.
        body: filled
          ? 'It has ' + filled + ' of 10 sizes recorded. Sets already made with it keep their own sizes.'
          : 'It has no sizes in it.',
        ok: 'remove it'
      }).then(function (yes) {
        if (!yes) return;
        return post('/api/staff/recipe', {
          sessionToken: S.session.token,
          customerId: data.customer.id,
          shape: shape, length: length, remove: true
        }).then(reload);
      });
    });
  }

  function editCell(btn) {
    var input = document.createElement('input');
    input.className = 'hqc__cell hqc__cell--edit';
    input.value = String(btn.textContent).replace(/[^0-9.]/g, '');
    input.inputMode = 'decimal';
    btn.replaceWith(input);
    input.focus();
    input.select();

    var done = false;
    function commit(save) {
      if (done) return;
      done = true;
      var raw = input.value.trim();
      var val = raw === '' ? null : Number(raw);
      if (raw !== '' && !isFinite(val)) { input.replaceWith(btn); return; }
      if (!save) { input.replaceWith(btn); return; }

      if (btn.dataset.m) saveMeasurement(btn.dataset.m, Number(btn.dataset.i), val);
      else saveRecipeCell(btn.dataset.r, Number(btn.dataset.i), val);
    }
    input.addEventListener('blur', function () { commit(true); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') commit(true);
      if (e.key === 'Escape') commit(false);
    });
  }

  function flash(text) {
    var el = root.querySelector('#hqc-saved');
    if (!el) return;
    var was = el.textContent;
    el.textContent = text;
    setTimeout(function () { el.textContent = was; }, 1400);
  }

  function saveMeasurement(key, index, value) {
    data.measurements[key][index] = value;
    var m = data.measurements;
    post('/api/staff/measurements', {
      sessionToken: S.session.token,
      customerId: data.customer.id,
      leftWidth: m.leftWidth, leftHeight: m.leftHeight,
      rightWidth: m.rightWidth, rightHeight: m.rightHeight
    }).then(function (res) {
      if (!res.data.ok) { window.TN && window.TN.showToast(res.data.error || 'Could not save.'); return; }
      // Filling the last gap is what marks them measured, so the label has to
      // say so — otherwise the promotion is invisible and gets done twice.
      if (res.data.promoted) {
        data.stage.profile = 'complete';
        flash('measured ✦');
      } else {
        flash('saved ✦');
      }
      return reload();
    });
  }

  function saveRecipeCell(key, index, value) {
    var parts = key.split('|');
    var shape = parts[0], length = parts[1], which = parts[2];
    var rec = data.recipes.filter(function (r) {
      return r.shape === shape && r.length === length;
    })[0];
    if (!rec) return;
    rec.sizes[which][index] = value;
    post('/api/staff/recipe', {
      sessionToken: S.session.token,
      customerId: data.customer.id,
      shape: shape, length: length, sizes: rec.sizes
    }).then(function () { flash('saved ✦'); return reload(); });
  }

  // The builder's own five and five, in its own order. Typed free-hand this
  // was one keystroke away from creating an "almnod" recipe that would never
  // match an order and never announce itself -- the same spelling problem we
  // just fixed between the build page and the product page.
  var SHAPES = ['almond', 'square', 'coffin', 'oval', 'stiletto'];
  var LENGTHS = ['short', 'medium', 'long', 'xl', 'xxl'];

  function addRecipe() {
    window.HQ.dialog({ title: 'which shape?', choices: SHAPES }).then(function (shape) {
      if (!shape) return;
      window.HQ.dialog({ title: 'which length?', choices: LENGTHS }).then(function (length) {
        if (!length) return;
        createRecipe(shape, length);
      });
    });
  }

  function createRecipe(shape, length) {
    post('/api/staff/recipe', {
      sessionToken: S.session.token,
      customerId: data.customer.id,
      shape: shape, length: length,
      sizes: { left: [null, null, null, null, null], right: [null, null, null, null, null] }
    }).then(reload);
  }

  function reload() {
    return post('/api/staff/client', {
      sessionToken: S.session.token, customerId: data.customer.id
    }).then(function (res) {
      if (res.data.ok) { data = res.data; render(); }
    });
  }

  window.HQClient = {
    render: function (el, sharedState, customerId) {
      root = el;
      S = sharedState;
      root.className = 'hqc';
      root.innerHTML = '<div class="hq__msg"><strong>Loading…</strong><span>Fetching their profile.</span></div>';
      return post('/api/staff/client', { sessionToken: S.session.token, customerId: customerId })
        .then(function (res) {
          if (!res.data.ok) {
            root.innerHTML = '<div class="hq__msg"><strong>Couldn’t load</strong><span>' +
              esc(res.data.error || 'That customer could not be found.') + '</span></div>';
            return;
          }
          data = res.data;
          render();
        });
    }
  };
})();
